import { AcaCoreModule } from '@aca/core';
import { AcaDateTimeModule } from '@aca/datetime';
import { AcaUiModule } from '@aca/ui';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Injector, NgModule, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AcadvLoadingComponent } from './components/loading.component';
import { SharedDropdownComponent } from './components/shared-dropdown/shared-dropdown.component';
import { RequireRoleDirective } from './directives/require-role.directive';
import { ServerReceiveService } from './services/server-receive.service';

/**
 * Bootstrap modules for shell application only
 * DO NOT import in remote MFEs
 */
export const BootstrapModules = [BrowserModule, BrowserAnimationsModule];

/**
 * IMPORTANT: Material modules removed from SharedServicesModule
 * 
 * Previously exported: MatMenuModule, MatBadgeModule, MatAutocompleteModule
 * 
 * WHY REMOVED:
 * - Exporting Material modules from a shared module causes NG0912 component collision errors
 * - When multiple MFEs import SharedServicesModule, Material components get registered multiple times
 * - Module Federation singleton configuration handles Material sharing at webpack level
 * 
 * MIGRATION:
 * - Each MFE should import Material modules directly in their entry module or components
 * - Example: import { MatMenuModule } from '@angular/material/menu' in component
 * - See: documentation/ANGULAR_MATERIAL_IMPORT_PATTERNS.md
 */

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        AcaCoreModule,
        AcaUiModule,
        AcaDateTimeModule,
        HttpClientModule,
        AcadvLoadingComponent,
        SharedDropdownComponent,
        RequireRoleDirective
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        FormsModule,
        AcaCoreModule,
        AcaUiModule,
        AcaDateTimeModule,
        AcadvLoadingComponent,
        SharedDropdownComponent,
        RequireRoleDirective
    ],
    providers: [] // purposely empty; use shell's app.providers.ts
})
export class SharedServicesModule {
  static serverReceiveService: ServerReceiveService;

  constructor() {
    const injector = inject(Injector);

    SharedServicesModule.serverReceiveService = injector.get<ServerReceiveService>(ServerReceiveService);
  }
}
